import {
  GetSecretValueCommand,
  GetSecretValueResponse,
  SecretsManagerClient,
  SecretsManagerClientConfig,
} from '@aws-sdk/client-secrets-manager';

import ENVIRONMENT_VARIABLES from '../../constants/environmentVariables';
import { getAWSServiceCredentials } from '../authUtils';
import { logger } from '../logger';

/**
 * Retrieves a secret from AWS Secrets Manager
 * Uses caching to reduce API calls
 *
 * @param secretName The name of the secret to retrieve
 * @param region Optional AWS region to use for the Secrets Manager client. If not provided, uses the default region from environment variables
 * @returns A Promise that resolves to the secret information
 */
export const retrieveSecret = async (secretName: string, region?: string): Promise<GetSecretValueResponse> => {
  try {
    // Secret not in cache or expired, fetch from Secrets Manager
    const secretsManagerConfig: SecretsManagerClientConfig = {
      region: region || ENVIRONMENT_VARIABLES.env.Region,
      credentials: await getAWSServiceCredentials(),
    };

    const secretsManagerClient = new SecretsManagerClient(secretsManagerConfig);
    const command = new GetSecretValueCommand({ SecretId: secretName });

    const response = await secretsManagerClient.send(command);
    return response;
  } catch (error) {
    logger.error(`Error retrieving secret ${secretName} from Secrets Manager:`, { error: error });
    throw error;
  }
};
